import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import {
  addHolidayService,
  deleteholiday,
  getAllholidaylist,
  updateHoliday,
  updateHolidayStatus,
} from "../../Api/services/holidayService";

const historySlice = createSlice({
  name: "holiday",
  initialState: {
    holidayData: [],
    error: null,
    loading: false,
    add: "",
  },
  extraReducers: (builder) => {
    //add holiday user
    builder
      .addCase(addHolidayService.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(addHolidayService.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error("error");
        } else {
          toast.success("add data successfuly");
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(addHolidayService.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //get holiday list
    builder
      .addCase(getAllholidaylist.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getAllholidaylist.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action.payload);
        }
        return {
          ...state,
          holidayData: action.payload,
          loading: false,
        };
      })
      .addCase(getAllholidaylist.rejected, (state, action) => {
        toast.error(action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //update holiday
    builder
      .addCase(updateHoliday.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(updateHoliday.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(updateHoliday.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });

    //update holiday status
    builder
      .addCase(updateHolidayStatus.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(updateHolidayStatus.fulfilled, (state, action) => {
        if (action?.payload?.status === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(updateHolidayStatus.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
    //delete holiday

    builder
      .addCase(deleteholiday.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(deleteholiday.fulfilled, (state, action) => {
        if (action?.payload?.success === false) {
          toast.error(action?.payload);
        } else {
          toast.success(action?.payload?.message);
        }
        return {
          ...state,
          loading: false,
        };
      })
      .addCase(deleteholiday.rejected, (state, action) => {
        toast.error(action?.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      });
  },
});

export default historySlice.reducer;
